import { Box, FontSizeOptions, TextNew } from '@jfs/ui-new'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { styles } from './styles'
import { itemSelected } from './types'
interface RadioButtonDropdownInterface {
  data: any
  isExportType: boolean
  onDropdownItemPress: (itemSelected: itemSelected) => void
  selectedValue?: string
  fontSize?: FontSizeOptions | number
  height: number
  width: number
  testId?: string
}

export const DefaultDropDown = ({
  data,
  isExportType,
  onDropdownItemPress,
  selectedValue = '',
  fontSize,
  height,
  width,
  testId,
}: RadioButtonDropdownInterface) => {
  return (
    <ModBox show={!isExportType} width={width} maxHeight={height} overflow={data?.length > 5 ? "auto" : undefined}>
      {data?.map((item: any, index: number) => {
        return (
          <Box
            {...styles.defaultDropdown}
            key={`${item.value}+${index}`}
            onPress={(_evt: any) => {
              !item.disabled && onDropdownItemPress(item)
            }}
            testID={`defaultDropDown-${index}`}
            borderBottomWidth={index === data?.length - 1 ? 0 : 1}
            disabled={item.disabled ?? false}
            bg={item.disabled ? 'DISABLED_GREY' : undefined}>
            <TextNew
              {...styles.defaultTextStyle}
              fontSize={fontSize}
              color={selectedValue === item.value ? 'BLUE' : 'BLACK'}>
              {item?.value ?? ''}
            </TextNew>
          </Box>
        )
      })}
    </ModBox>
  )
}
